import { render, staticRenderFns } from "./ThgDescriptionSvgYearly.vue?vue&type=template&id=20c129f1"
import script from "./ThgDescriptionSvgYearly.vue?vue&type=script&lang=ts"
export * from "./ThgDescriptionSvgYearly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports